export default __webpack_public_path__ + "static/media/rightArrow.074da75e.svg";